import { queryOptions } from '@tanstack/react-query';
import { getClickeableEvents } from '@/features/locations/presentation/actions/get-clickeable-events';
import { getFullUserLocations } from '@/features/locations/presentation/actions/get-full-user-locations';
import { getLocationTimeTemplates } from '@/features/locations/presentation/actions/get-location-time-templates';

/**
 * Listado de locales del usuario en sesión. El `scope` es el id del usuario: el resultado depende solo de la sesión
 * (lo filtra RLS: admin, dueño, cajero o grupo), por eso servidor (`claims.sub`) y cliente (`user.id`) calculan la misma
 * key y el prefetch del layout hidrata `useLocations`.
 */
export const locationsKeys = {
  all: ['locations'] as const,
  list: (scope: string) => [...locationsKeys.all, 'list', scope] as const,
};

export const locationTimeTemplatesKeys = {
  all: ['location-time-templates'] as const,
  byLocation: (locationSlug: string) => [...locationTimeTemplatesKeys.all, locationSlug] as const,
};

export const clickeableEventsKeys = {
  all: ['clickeable-events'] as const,
  byLocation: (locationId: string | undefined) => [...clickeableEventsKeys.all, locationId] as const,
};

export const locationsListQueryOptions = (scope: string) =>
  queryOptions({
    queryKey: locationsKeys.list(scope),
    queryFn: () => getFullUserLocations(),
  });

export const locationTimeTemplatesQueryOptions = (locationSlug: string) =>
  queryOptions({
    queryKey: locationTimeTemplatesKeys.byLocation(locationSlug),
    queryFn: () => getLocationTimeTemplates({ locationSlug }),
  });

export const clickeableEventsQueryOptions = (locationId: string | undefined) =>
  queryOptions({
    queryKey: clickeableEventsKeys.byLocation(locationId),
    queryFn: () => getClickeableEvents(locationId ?? ''),
    enabled: Boolean(locationId),
  });
